// src/routes/userRoutes.js
import React from 'react';
import { Navigate, Route } from 'react-router-dom';

// Import user components
import Users from '../pages/users/Users';
import UserCreateEdit from '../pages/users/UserCreateEdit';
import UserDetail from '../pages/users/UserDetail';

// Import permissions check
import ProtectedRoute from '../components/auth/ProtectedRoute';

const userRoutes = [
  // Users list page
  <Route 
    path="users" 
    element={
      <ProtectedRoute requiredPermission={{ resource: 'users', action: 'read' }}>
        <Users />
      </ProtectedRoute>
    } 
  />,
  
  // User create page
  <Route
    path="users/create"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'users', action: 'create' }}>
        <UserCreateEdit />
      </ProtectedRoute>
    }
  />,
  
  // User edit page
  <Route
    path="users/:id/edit"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'users', action: 'update' }}>
        <UserCreateEdit />
      </ProtectedRoute>
    }
  />,
  
  // User detail page
  <Route
    path="users/:id"
    element={
      <ProtectedRoute requiredPermission={{ resource: 'users', action: 'read' }}>
        <UserDetail />
      </ProtectedRoute>
    }
  />,
  
  // Redirect /users/* to /users if no match
  <Route path="users/*" element={<Navigate to="/users" replace />} />
];

export default userRoutes;